@if (appSettings.isMobile()) {
  <!-- Vista Móvil: Compacta en una sola fila -->
  <div class="page-header-mobile d-flex align-items-center justify-content-between mb-3"
       [class.page-header-unified]="unifiedOnMobile || showBack">
    <div class="d-flex align-items-center gap-2 text-truncate">
      @if(showBack) {
        <a href="javascript:;" (click)="back.emit()" class="text-decoration-none text-dark me-2 cursor-pointer d-inline-flex align-items-center" title="Volver">
          <i class="fas fa-arrow-left fa-lg"></i>
        </a>
      } @else if(icon) {
        <i [class]="icon" class="text-muted"></i>
      }
      <h2 class="page-header-title-mobile mb-0 text-truncate">
        {{ mobileTitle ?? title }}
      </h2>
      <app-help-panel></app-help-panel>
    </div>

    <div class="d-flex align-items-center gap-2 flex-shrink-0">
      <ng-content select="[headerExtra]"></ng-content>
      @if(hasOptions) {
        <button type="button" class="btn btn-xs btn-white border shadow-sm fw-semibold"
          (click)="toggleMenu()" [title]="optionsLabel">
          <i [class]="optionsIcon" class="me-1"></i>
          <span>{{ optionsLabel }}</span>
        </button>
      }
    </div>
  </div>
} @else {
  <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
    <h1 class="page-header d-flex align-items-center gap-2 mb-0">
      @if (!showBack && icon) {
        <i [class]="icon"></i>
      }
      {{ title }}
      <app-help-panel></app-help-panel>
    </h1>
    <div class="d-flex align-items-center justify-content-end gap-2 flex-shrink-0">
      <ng-content select="[headerExtra]"></ng-content>
      @if (showBack) {
        <button type="button" class="btn-close" (click)="back.emit()" aria-label="Cerrar" title="Cerrar"></button>
      }
      @if (hasOptions) {
        <div class="dropdown-toggle position-relative">
          <a href="javascript:;" (click)="toggleMenu()"
             class="text-decoration-none text-dark text-opacity-75 cursor-pointer">
            <i [class]="optionsIcon" class="fa-fw me-1 text-dark text-opacity-50"></i>
            {{ optionsLabel }}<b class="caret"></b>
          </a>
        </div>
      }
    </div>
  </div>
}

<!-- Contenedor ÚNICO de Opciones (evita duplicar ng-content) -->
@if(hasOptions && isOpen()) {
  <div class="dropdown-menu dropdown-menu-end show page-header-dropdown shadow">
    <!-- Cabecera visible únicamente en móvil a pantalla completa -->
    @if(appSettings.isMobile()) {
      <div class="sticky-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex align-items-center gap-2 fw-bold text-uppercase fs-14">
          <i [class]="optionsIcon"></i>
          <span>{{ optionsLabel }}</span>
        </div>
        <button type="button" class="btn btn-sm btn-outline-danger text-body text-opacity-75 text-decoration-none p-0"
          (click)="closeMenu()" aria-label="Cerrar">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
    }

    <!-- Contenido proyectado de opciones -->
    <div class="page-header-options-body" (click)="onOptionClick($event)">
      <ng-content select="[headerOptions]"></ng-content>
    </div>
  </div>
}
